<template>
  <div style="display:flex;">
    <CHeaderNavItem class="m-auto fw-bold">
      <button v-if="isSwitched" @click="exitUserSwitch" class="c-header-nav-btn text-center fw-bold" style="display: block;">
        <CIcon name="cil-warning" /> Wechsel zu <strong>{{user.name}}</strong> beenden
      </button>
    </CHeaderNavItem>
  <CDropdown
    inNav
    class="c-header-nav-items theheaderaccount"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink ref="userdropdown">
        <div class="c-avatar dropdown-toggle">
          <CIcon name="cil-user"/>
        </div>
      </CHeaderNavLink>
    </template>

    <CDropdownHeader tag="div" color="light" class="text-center">
      <strong>Mitarbeiter</strong>
    </CDropdownHeader>

    <CDropdownItem disabled>
      <span class="text-center" style="width: 100%;">
        {{ name }}
      </span>
    </CDropdownItem>

    <CDropdownItem disabled style="padding-top: 0;">
      <span class="text-center" style="width: 100%; font-size: 0.6rem;">
        Letzter Login am
        <br>
        {{last_login|moment('DD.MM.YYYY')}}
        um
        {{last_login|moment('HH:mm:ss')}} Uhr
      </span>
    </CDropdownItem>

    <CDropdownDivider/>

    <CDropdownItem to="/profile/password">
      <CIcon name="cil-https" /> Mein Passwort Ändern
    </CDropdownItem>

    <CDropdownItem to="/security/logout" class="text-center" style="display: block;">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return {
      name: ''
    }
  },
  computed: {
    user: function () {
      return this.$store.getters['security/user']
    },
    switchedFrom: function () {
      return this.$store.getters['security/baseUser']
    },
    isSwitched: function () {
      return this.$store.getters['security/isSwitched']
    },
    last_login () {
      return (this.user ? this.user.last_login : '')
    }
  },
  mounted () {
    this.getName()
  },
  methods: {
    async getName () {
      const mitarbeiterloaded = await this.loadMitarbeiter()
      const curUser = mitarbeiterloaded.data.filter(mitarbeiter => {
        return mitarbeiter.mitarbeiterid === this.user.userid
      })

      this.name = curUser[0].name
    },
    async loadMitarbeiter () {
      return Vue.axios.get('/mitarbeiter/get')
    },
    async exitUserSwitch () {
      const self = this
      this.$store.dispatch('security/AUTH_USER_SWITCH_EXIT').then(() => {
        self.$snotify.success('Du hast den Benutzerwechsel beendet.', {
          position: 'rightTop',
          timeout: 4000
        })
        self.$router.push({ path: '/mitarbeiter/uebersicht' }).then(() => {
          self.$router.go(0)
        }).catch(() => { self.$router.go(0) })
      }).catch(() => {
        self.$snotify.error('Das hat nicht funktioniert.', {
          position: 'rightTop',
          timeout: 4000
        })
      })
    }
  }
}
</script>

<style lang="scss">
  li.theheaderaccount {
    .c-icon {
      margin-right: 0.3rem;
    }
    a.disabled {
      color: rgba(0, 0, 21, 0.5) !important;
    }
  }
</style>
